module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am Glandion.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am a contemplative.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I embrace the life and role of the Holy Spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love a good wine.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love fellowship and friendships.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am a deep, caring person.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am a worrier and a burden bearer.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I take time to notice.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am soft-spoken yet strong in spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love jazz, as well as the Gregorian chant.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am consciously aware of my sinful nature.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am a great listener.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am a priest, a husband and father of four adult children.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am a grandpa, affectionately called “Papa.”")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I long to remain in the presence of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I like to celebrate.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I don’t have to act in a cultural manner to define my African American identity.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am a crosscultural man.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I think about my death about once a week.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I think about my life and want to do the things that matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love to laugh yet I cry easily.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love poetry, especially T. S. Eliot and Garrison Keillor.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love coffee.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I question myself all the time.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I have never sensed the condemnation of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I don’t think about former accomplishments as much as my")]), _vm._v(" "), _c('i', [_vm._v("failures.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I believe in justice.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I have stood in lines in Ethiopia with the hungry and the poor.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I have traveled to eastern Africa during the time of genocide, war and famine.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I minister in one of the wealthiest communities in the United States.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I have learned that the rich in resources can also be poor in spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I embrace the Scriptures and see them as a guidepost for life.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I have struggled to accept the diagnosis of a disease and tried to cover it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love the Father, Son and Holy Spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love the Eucharist.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I embrace another person’s heart, whatever their religious practice.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I believe evil will be overcome.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love to see the sunset.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I take time to look in the eyes of others to get a glimpse of their heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I like to raid the cookie jar in the middle of the night.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I love theological discussions.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am loved.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am loving.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am Glandion.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I have Parkinson’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("I am learning to walk in grace.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2098b22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/prose.vue
// module id = 69
// module chunks = 0